import React, { useEffect, useCallback, useState} from 'react';
import EffectParameterSlider from './EffectParameterSlider.js';
import Dropdown from 'react-dropdown';
import {
    FORWARD,
    REVERSE,
    FORWARD_REVERSE,
    BROWNIAN} from 'constants/playhead-directions.js';
import {connect} from 'react-redux';

const PlayheadEffectComponent = ({effect, direction, sequencerEngine}) => { 
    const options = [
        {label: "Forward", value: FORWARD},
        {label: "Reverse", value: REVERSE},
        {label: "Forward-Reverse", value: FORWARD_REVERSE},
        {label: "Brownian", value: BROWNIAN},
    ];

    const onChangeDirection = useCallback((opt) => {
        effect.directionParameter.set(opt.value, undefined, undefined);
    }, [effect]);

    return (
        <div>
          <div className="direction-parameter">
            <div className="parameter-label">
              Direction:
            </div>
              <Dropdown
                className='osc-type-dropdown float-left'
                controlClassName='osc-type-control-dropdown'
                arrowClassName='osc-type-arrow-dropdown'
                options={options}
                onChange={onChangeDirection}
                value={options.find(x => x.value === direction)}
                placeholder="Direction" />
          </div>
          {direction !== BROWNIAN ? 
           <div>
             <EffectParameterSlider
                 name={'Speed'}
                 parameter={effect.speedFactorParameter}
                 onParameterChanged={() => []}
                 isParameter={true}
                 sequencerEngine={sequencerEngine}
                 lfoEnabled={true}
                 unit="x"
                 step={0.25}
                 min={0.25}
               max={window.isNFT ? 1: 4}/>
             <div className="offset-parameter">
             <EffectParameterSlider
                 name={'Offset'}
                 parameter={effect.offsetParameter}
                 onParameterChanged={() => []}
                 isParameter={true}
                 sequencerEngine={sequencerEngine}
                 lfoEnabled={true}
                 unit="x"
                 step={1}
                 min={0}
                 max={16}/>
             </div>
          </div>: 
          <EffectParameterSlider
            name={'Walk'}
            parameter={effect.walkParameter}
            onParameterChanged={() => []}
            isParameter={true}
            sequencerEngine={sequencerEngine}
            lfoEnabled={true}
            unit="Steps (1/32th)"
            step={1}
            min={1}
            max={16}/>}
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
      direction: props.effect.direction
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PlayheadEffectComponent);
